let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Y6Bx")).then(() => parcelRequire('cPug3'));